import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import ServiceDetail from "../pages/services/ServiceDetail";
import Projects from "../pages/projects/page";
import About from "../pages/about/page";
import Blog from "../pages/blog/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hizmetler",
    element: <Services />,
  },
  {
    path: "/hizmetler/:slug",
    element: <ServiceDetail />,
  },
  {
    path: "/projeler",
    element: <Projects />,
  },
  {
    path: "/hakkimizda",
    element: <About />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/iletisim",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
